export default {
  primary: '#009688',
  black: '#000000',
  pink: '#E91E63',
  yellowOrange: '#FF9800',
  denim: '#3a5d87',
  darkDenim: '#2f2e41'
}